import { render, staticRenderFns } from "./salesman.vue?vue&type=template&id=32e615e0&scoped=true"
import script from "./salesman.vue?vue&type=script&lang=js"
export * from "./salesman.vue?vue&type=script&lang=js"
import style0 from "./salesman.vue?vue&type=style&index=0&id=32e615e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e615e0",
  null
  
)

export default component.exports